import React from 'react';
import { Modal, Box, TextField, MenuItem, IconButton, Button, CircularProgress } from '@material-ui/core';

const modalWrapperStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  maxHeight: '90vh',
  backgroundColor: 'white',
  borderRadius: 12,
  boxShadow: 24,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle = {
  backgroundColor: '#75287C',
  color: 'white',
  padding: '0px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  minHeight: 56,
};

const contentStyle = {
  padding: 24,
  flex: 1,
  overflowY: 'auto',
};

const actionsStyle = {
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  borderTop: '1px solid #eee',
};

const FormModalExpertConsultation = ({
  open,
  onClose,
  isPersonaLoading,
  formData,
  handleInputChange,
  uniqueExpertConsultInstanceId,
  onSubmit,
  isEdit,
  handleUpdateButtonClick,
  submitExpertConsultPersonaForm,
  expertConsiltAlreadyFilledPersonaInstanceId
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box style={modalWrapperStyle}>
        
        {/* Header */}
        <Box style={headerStyle}>
          <div>Expert Consultation Persona Form</div>
          <IconButton onClick={onClose} style={{ color: 'white' }}>
            X
          </IconButton>
        </Box>

        {/* Form content */}
        <Box style={contentStyle} className={`${isPersonaLoading ? "set-opacity" : ""}`}>
          {isPersonaLoading && (
            <div className="center-screen">
              <CircularProgress />
            </div>
          )}

          <TextField
            select
            name="nResourceInstanceId"
            label="Resource Instance Id"
            value={formData["nResourceInstanceId"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            // SelectProps={{
            //   MenuProps: {
            //     PaperProps: {
            //       style: {
            //         maxHeight: 200,
            //         width: 300,
            //       },
            //     },
            //   },
            // }}

            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    width: 300,
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null, // Very important in MUI v4
              },
            }}
            disabled={isEdit ? true : true} // resource id change nahi hone paye so disablibng for both add and edit
          >
            {uniqueExpertConsultInstanceId.map((option) => (
              <MenuItem key={option} value={option}
              disabled={expertConsiltAlreadyFilledPersonaInstanceId?.includes(option)}
              >{option}</MenuItem>
            ))}
          </TextField>

          <TextField
            name="Reason to opt Expert Consultation"
            label="Reason to opt Expert Consultation"
            value={formData["Reason to opt Expert Consultation"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />

          <TextField
            name="Theme"
            label="Theme"
            value={formData["Theme"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />

          <TextField
            name="Expert name"
            label="Expert name"
            value={formData["Expert name"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={true}
          />

          <TextField
            name="Output"
            label="Output"
            value={formData["Output"]}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
        </Box>

        {/* Action Buttons */}
        <Box style={actionsStyle}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          {
            isEdit ? (
              <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }}  onClick={()=>handleUpdateButtonClick(formData)}>
            Update
          </Button>
            ):(
              <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }}  onClick={()=>submitExpertConsultPersonaForm(formData)}>
            Submit
          </Button>
            )
          }
        </Box>

      </Box>
    </Modal>
  );
};

export default FormModalExpertConsultation;
